<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-wizard
			ref="form_wizard"
			title=""
			subtitle=""
			shape="circle"
			color="#1c4a50"
			class="p-0 mt-4"
		>
			<tab-content title="Company">
				<form-company action="create" class="form-sm">
					<template #return>
						<base-button
							@click.native="exitSetup"
							:disabled="formProcessing"
							type="white"
							size="md"
							class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
							>Cancel</base-button
						>
					</template>
					<template #submit-text>Save & Continue</template>
				</form-company>
			</tab-content>
			<tab-content title="Admin">
				<form-company-admin
					v-if="companySvc.company.id"
					:company-id="companySvc.company.id"
					action="create"
					class="form-sm"
				>
					<template #header>
						<h4 class="mb-1">Add Company Admin</h4>
						<p class="mb-4 text-sm">
							Additional company admins can be added after company
							setup is complete.
						</p>
					</template>

					<template #return>
						<base-button
							@click.native="exitSetup"
							:disabled="formProcessing"
							type="white"
							size="md"
							class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
							>Cancel</base-button
						>
					</template>
					<template #submit-text>Save & Continue</template>
					<template #submit-extra>
						<a
							@click.prevent.stop="$refs.form_wizard.nextTab()"
							class="mt-3 text-center d-block small"
							href
							>Skip for now</a
						>
					</template>
				</form-company-admin>
			</tab-content>
			<tab-content title="Reports">
				<form-report-access
					v-if="companySvc.company.id || memberSvc.member.id"
					:instance="memberSvc.member"
					:params="{
						assignee: 'Corporate Admin',
						page_size: 1000,
					}"
					assign-from="report"
					assign-to="company"
					:company-id="companySvc.company.id"
					new-resource
				>
					<template #header>
						<h4 class="mb-1">Assign Report Access</h4>
						<p class="mb-4 text-sm">
							Assigning reports is optional at this point. You can
							manage reports for this company at any time.
						</p>
					</template>

					<template #return>
						<base-button
							@click.native="exitSetup"
							:disabled="formProcessing"
							type="white"
							size="md"
							class="px-0 bg-transparent font-weight-normal shadow-none"
							>Cancel</base-button
						>
					</template>
					<template #submit-text>Save & Finish</template>
				</form-report-access>
			</tab-content>

			<div slot="footer" class="d-flex justify-content-between"></div>
		</form-wizard>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import { FormWizard, TabContent } from "vue-form-wizard";
import FormCompany from "@components/FormCompany";
import FormCompanyAdmin from "@components/FormCompanyAdmin";
import FormReportAccess from "@components/FormReportAccess";

export default {
	name: "modal-add-company",
	components: {
		FormWizard,
		TabContent,
		FormCompany,
		FormCompanyAdmin,
		FormReportAccess,
	},
	inject: ["companySvc", "memberSvc"],
	data() {
		return {
			syncModal: false,
			activeTab: "form",
			formProcessing: false,
		};
	},
	methods: {
		async exitSetup() {
			if (this.$refs.form_wizard.activeTabIndex == 2) {
				this.syncModal = false;

				this.reset();
			} else {
				let message = "Your changes will not be saved.";

				if (1 === this.$refs.form_wizard.activeTabIndex) {
					message = `Company ${this.companySvc.company.name} has been created; `;
					message +=
						"however, company admin information will not be saved. You can add a company admin, users and reports for this company at any time.";
				}

				const conf = await this.$swal({
					title: "Exit Setup",
					text: message,
					confirmButtonText: "Exit Setup",
				});

				if (!conf.value) return false;

				this.syncModal = false;

				if (1 === this.$refs.form_wizard.activeTabIndex) this.reset();
			}
		},
		reset() {
			this.companySvc.set("company", null);
			this.memberSvc.set("member", null);
		},
	},
	mounted() {
		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("add-company" === payload.key) this.syncModal = payload.active;
		});

		this.$bus.trackEvent("company-form-success", () => {
			if (this.$refs.form_wizard) this.$refs.form_wizard.nextTab();
		});

		this.$bus.trackEvent("company-admin-form-success", () => {
			if (this.$refs.form_wizard) this.$refs.form_wizard.nextTab();
		});

		this.$bus.trackEvent("report-access-form-success", () => {
			this.formProcessing = false;
			this.syncModal = false;

			this.reset();
		});

		this.$bus.trackEvent("error-catched", () => {
			this.formProcessing = false;
		});
	},
	beforeDestroy() {
		this.reset();
	},
};
</script>
